import { useCallback, useState } from "react";
import { SidebarNav } from "@/components/markyt/SidebarNav";
import { cn } from "@/lib/utils";

const STORAGE_KEY = "markyt-nav-collapsed";

/** Persistent desktop sidebar (≥880px). Collapses to an icon-only rail. */
export function MarkytSidebar() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
      } catch {}
      return next;
    });
  }, []);

  return (
    <aside
      className={cn(
        "sticky top-0 hidden h-screen shrink-0 transition-[width] duration-200 min-[880px]:flex",
        collapsed ? "w-[76px]" : "w-[248px]",
      )}
    >
      <SidebarNav collapsed={collapsed} onToggleCollapse={toggleCollapsed} />
    </aside>
  );
}
